// extracted by mini-css-extract-plugin
module.exports = {"freight-forwarder":"FreightForwarder_freight-forwarder__to_7s"};